// extracted by mini-css-extract-plugin
export default {"container":"selected-skills_container__9Tnv2"};